function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceAvailableHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.12,17c-2.75,0-5-2.53-5-5.59A5.09,5.09,0,0,1,15,6h.15a5.11,5.11,0,0,1,5,5.21v.13C20.1,14.41,17.86,17,15.12,17Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66,23.43H15.89L21,18.38a1.82,1.82,0,0,0-1.78,0,6.24,6.24,0,0,0-1,1,3.86,3.86,0,0,1-2.48.86H15a3.94,3.94,0,0,1-2.53-.86,6.8,6.8,0,0,0-1.13-.94,2,2,0,0,0-2.41.38,18.78,18.78,0,0,0-2.52,3.85L6,23.49c-.17.37-.35,1-.09,1.35a2,2,0,0,0,1.52.48H17.71Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.25 22.69 22.07 18.56 22.07 18.56 17.89 22.69 18.9 22.69 18.9 26 25.1 26 25.05 22.69 26.25 22.69",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.28,
    y: 22.8,
    width: 1.58,
    height: 3.14,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailableHome);
export default __webpack_public_path__ + "static/media/presence-available-home.d30a07c2.svg";
export { ForwardRef as ReactComponent };